import $axios from '~/plugins/axios';
import i18next from 'i18next';

import { Api, GetReleaseNotesParams, ReleaseNote } from '~/api';
import { buildModule } from '../utils';
import { DEFAULT_RELEASE_NOTE_LOCALE, Dict, getReleaseNoteLocale } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedReleaseNotes: {} as Dict<ReleaseNote>,
	})
	.withGetters({
		byId: state => (releaseNoteId: string) => (
			state.storedReleaseNotes[releaseNoteId] ?? null
		),
	})
	.withMutations({
		STORE_RELEASE_NOTE (state, releaseNote: ReleaseNote) {
			state.storedReleaseNotes = {
				...state.storedReleaseNotes,
				[releaseNote.name]: releaseNote,
			};
		},
	})
	.withActions({
		async get ({ commit }, params: Omit<GetReleaseNotesParams, 'locale' | 'limit'>) {
			const locale = getReleaseNoteLocale(i18next.language) ?? DEFAULT_RELEASE_NOTE_LOCALE;

			const { data } = await api.get('/release-notes', {
				params: {
					...params,
					limit: 1,
					locale: locale,
				},
			});

			if (data.payload.length < 1) {
				return;
			}

			commit('STORE_RELEASE_NOTE', data.payload[0]);
		},
		async markAsRead (_, id: string) {
			const { data: _data } = await api.put(`/release-notes/${ id }`, {
				type: 'web',
			});
		},
	});
